import {ChangeableField} from './types'

export const NOT_EDITABLE_FIELD: ChangeableField = {state: 'notChangeable', isDirty: false}
